import { Button } from "@/components/ui/button";
import { MessageSquareText } from "lucide-react";
import { cn } from "@/lib/utils";

interface IProps {
  onClick: () => void;
  hasFeedback?: boolean;
}

export const FeedbackButton: React.FC<IProps> = ({ onClick, hasFeedback }) => {
  return (
    <div className="relative">
      <Button variant="outline" size="icon" onClick={onClick}>
        <MessageSquareText className={cn("h-5 w-5 text-gray-900")} />
      </Button>
      {hasFeedback && <span className="bg-warning absolute right-2 top-2 h-2 w-2 rounded-full"></span>}
    </div>
  );
};
